import { Button } from 'components/button/Button'
import { SMemoryGalleryPlaceholder } from './MemoryGalleryPlaceholder.styled'
import { useTakePhotoModal } from 'components/content/singingPortraits/takePhotoModal/TakePhotoModal'
import { Icon } from 'components/icon'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { GenericFunction } from 'utils/types'

export function MemoryGalleryPlaceholder(props: {
  onClick?: GenericFunction
  className?: string
  onUploadedSelfie?: (file: File) => void
}) {
  const { t } = useTranslation('life_stories')

  const [modal, open, close] = useTakePhotoModal((photo) => {
    close()
    props.onUploadedSelfie?.(photo)
  })

  return (
    <>
      {modal}
      <SMemoryGalleryPlaceholder
        className={props.className}
        icon="ImageAdd"
        title={t('life_stories.inside_page.gallery_empty.title')}
        description={t('life_stories.inside_page.gallery_empty.desc')}
        buttons={
          <>
            <Button
              onClick={() => open()}
              type="button"
              variant="secondary"
              leftIcon={<Icon name="Camera" />}
            >
              {t('life_stories.inside_page.gallery_empty.selfie_button')}
            </Button>
            <Button onClick={props.onClick} type="button" leftIcon={<Icon name="FileUpload" />}>
              {t('life_stories.inside_page.gallery_empty.action_button')}
            </Button>
          </>
        }
      />
    </>
  )
}
